module.exports = __webpack_public_path__ + "static/js/operation-worker.b74d0d7f.chunk.worker.js"